import React from 'react';
import c from 'classnames';
import InputField, { type InputFieldProps } from '../../../../lego/InputField';
import s from './LargeInputField.scss';

export interface Props extends InputFieldProps {
  /**
   * Squares off the end of the input to better flow into whatever is postfixed to it.
   */
  isPostfixed?: boolean;
}

const LargeInputField: React.FC<Props> = ({ isPostfixed, className, ...rest }) => {
  return (
    <InputField className={c(s['root'], isPostfixed && s['postfixed'], className)} {...rest} />
  );
};

LargeInputField.displayName = 'LargeInputField';

export default LargeInputField;
